import { useAppSelector } from '../app/typedReduxHooks'
import { hasOwnerOrSuperAdminProfileCapability } from '../features/users/utils/organizationAdminCapabilities'
import { Permission } from '../types/permission'

export type UseHasPermissionOptions = {
  includeOwnerSuperAdminFallback?: boolean
}

export function useHasPermission(
  permission: Permission,
  options?: UseHasPermissionOptions
): boolean {
  const authentication = useAppSelector((state) => state.authentication)
  const organizationAdmin = useAppSelector((state) => state.organizationAdmin.profile)

  const fromAuth = authentication.permissions?.includes(permission) ?? false
  const fromProfile =
    !!options?.includeOwnerSuperAdminFallback &&
    hasOwnerOrSuperAdminProfileCapability(organizationAdmin)

  return fromAuth || fromProfile
}
